export const hasFirebaseUserId = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return Boolean(payload.firebase_user_id);
  } catch {
    return false;
  }
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expiryTime = payload.exp * 1000 - 10000; // 10s buffer
    return Date.now() >= expiryTime;
  } catch {
    return true;
  }
};
